import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { withGuest } from '../features/auth/hocs';

export const LayoutBase: FC = withGuest(() => {
  return <Outlet />;
});
